<template>
  <div class>
     <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
      <v-card-title class="py-1 primary white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;" :class="$vuetify.theme.dark ? 'black' : 'primary'">
        <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
          <v-icon color="white" class="mr-2" medium>youtube_searched_for</v-icon>
          <span class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{$t("dashboards.recentPlayers")}}</span>
        </div>
        <v-btn class="pl-0 pr-0" text small :to="`/player-scout`" style="flex-shrink: 0;">
          <span class="white--text text-decoration-underline font-weight-bold">{{$t('dashboards.scout')}}</span>
          <v-icon small class="ml-1" color="white">keyboard_arrow_right</v-icon>
        </v-btn>
      </v-card-title>
      <div class="d-flex flex-column px-3 pt-2 pb-1 flex-grow-1" v-if="(players && players.length) && !loading" style="overflow:auto;">
        <PlayerDashboardItem :player="player" v-for="(player,index) in players" :key="index" embedded></PlayerDashboardItem>
      </div>
      <div class="d-flex flex-column px-3 pb-1 py-4 mb-7 text-center flex-grow-1" v-if="(!players || !players.length) && !loading">
        <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">emoji_people</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderLastScouted")}}</span>
      </div>
      <v-skeleton-loader v-if="loading" type="list-item@10" class="flex-grow-1"></v-skeleton-loader>
    </v-card>
  </div>
</template>

<script>
import PlayerService from "../../../services/player/player.service";
import PlayerDashboardItem from "../../player/PlayerDashboardItem";
import ResizeObserver from 'resize-observer-polyfill';
import * as moment from "moment";

export default {
  name: "LastPlayersSearch",
  components: {
    PlayerDashboardItem
  },
  props: {
  },
  data() {
    return {
      players: null,
      loading: false,
      observer: null
    };
  },
  filters: {
  },
  async mounted() {
    await this.loadViewData();
    this.observer = new ResizeObserver(this.onResize)
    .observe(this.$el)
  },
  methods: {
    async loadViewData() {
      await this.loadPlayers();
    },
    async loadPlayers() {
      this.loading = true;
      let playerResponse = await PlayerService.getLastPlayersSearch(10);
      this.players = _.chain(playerResponse.data).uniqBy("playerId").map(p => {
        p.time = moment(p.addedAt,'DD/MM/YYYY HH:mm').unix();
        return p
      }).orderBy(["time"],["desc"]).slice(0,10).value();
      this.loading = false;
    },
    onImgError(event,side){
      if(side === 'home'){
        game.homeTeamImgError = true;
      }else if(side === 'away'){
        game.awayTeamImgError = true;
      }
    },
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
  },
  destroyed () {
    delete this.observer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/LastPlayersSearch.vue